export default "__VITE_ASSET__B_p1Z22r__"